















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ExpandableControl extends Vue {
  @Prop({ default: false }) isActive!: boolean;

  @Prop({ default: false }) withIndicator!: boolean;

  isHovered = false;

  setHover(value: boolean) {
    this.isHovered = value;
  }

  get highlight(): boolean {
    return this.isActive || this.isHovered;
  }
}
